import React from "react";
import {
	AboutUsHero,
	WelcomeSection,
	YoutubeSection,
	MissionSection,
	TeamSection,
	ProgramsSection,
	PartnersSection,
} from "../../components/sections/about-us";

export default function AboutUs(props) {
	return (
		<>
			<AboutUsHero />

			<WelcomeSection />

			<YoutubeSection />

			<MissionSection />

			<TeamSection />

			<ProgramsSection />

			<PartnersSection />
		</>
	);
}
